// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".school-follow .target > .el-row[data-v-090ea800] {\n  margin-top: 10px;\n}\n.school-follow .target > .el-row .el-col[data-v-090ea800] {\n  height: 90px;\n  text-align: center;\n  background: red;\n}\n.school-follow .target > .el-row .el-col h4[data-v-090ea800] {\n  color: #fff;\n  font-size: 32px;\n  margin-top: 10px;\n}\n.school-follow .target > .el-row .el-col span[data-v-090ea800] {\n  display: block;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
